import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { detailQuestGetOneMainMatch_2 } from "../../config/apiSPA";

const parameter = { id: null, question: "", key: "" };

function ModalEditSoalMatch2({ show, onHide, submitClick, id, idMainMatch }) {
  const [val, setVal] = useState(parameter);
  const [spinner, setSpinner] = useState(true);

  function handleChange(mode, v) {
    switch (mode) {
      case "question":
        setVal({ ...val, question: v });
        break;
      case "kunci":
        setVal({ ...val, key: v });
        break;
    }
  }

  function handleSubmit(v) {
    setSpinner(true);
    setVal(parameter);
    submitClick(v);
  }
  function onHideModal() {
    setSpinner(true);
    setVal(parameter);
    onHide();
  }

  function onShow() {
    setVal({ ...val, id: id });
    detailQuestGetOneMainMatch_2(id).then((res) => {
      setSpinner(false);
      setVal({
        id: res.data.id,
        question: res.data.pertanyaan,
        key: res.data.kunci,
      });
    });
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          onHideModal();
        }}
        onShow={() => onShow()}
      >
        <ModalHeader closeButton>
          <h5 className="modal-title">Edit Matching Question</h5>
        </ModalHeader>
        <ModalBody>
          {spinner ? (
            <div className="spinner-border"></div>
          ) : (
            <>
              <div className="form-group mb-3">
                <label className="form-label">Question</label>
                <textarea onChange={(e) => handleChange("question", e.target.value)} defaultValue={val.question} className="form-control" />
                <label className="form-label">Key</label>
                <input onChange={(e) => handleChange("kunci", e.target.value)} defaultValue={val.key} className="form-control" />
              </div>
              <div className="alert bg-inverse bg-opacity-15">Edit matching question and this key. key can be containing letter or number base on your image</div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <button type="button" onClick={() => handleSubmit(val)} className={val.question !== "" && val.key !== "" ? "btn btn-outline-theme" : "btn btn-outline-theme disabled"}>
            Save changes
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ModalEditSoalMatch2;
